import { WebphonePhoneStateEvent } from '../types';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import { PcsConversationType } from '../lib/getPcsConversation';

const emitPcsConversationFetched = (
  pcsConversation: PcsConversationType,
  phoneStateUpdateEvent: WebphonePhoneStateEvent,
  logger: IAppLogger,
) => {
  logger.info(`PCS Conversation fetched: ${pcsConversation}`);

  appManager.events.emit('phone.pcs.conversation.fetched', {
    pcsConversation,
    phoneStateUpdateEvent,
  });
};

export default emitPcsConversationFetched;
